export default "__VITE_ASSET__ChWajqqs__"